function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 64.222h75.453V0H0z"
}));

var _ref2 = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M15.767 7.986l.24 10.35 8.544-4.333s-1.324-6.017-8.784-6.017m40.847 27.992a2.371 2.371 0 1 0 4.742 0 2.371 2.371 0 0 0-4.742 0m1.263-22.291a2.371 2.371 0 1 0 4.742 0 2.371 2.371 0 0 0-4.742 0",
  fill: "#BEFFFC"
}), React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  mask: "url(#b)",
  d: "M3 49h69V6H3zM2 6h71V1H2z"
}), React.createElement("path", {
  d: "M6.921 19.376a8.183 8.183 0 1 0 16.367 0 8.183 8.183 0 0 0-16.367 0z",
  stroke: "#28348A",
  strokeWidth: 0.4,
  mask: "url(#b)"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  mask: "url(#b)",
  d: "M9.268 24.927l5.866-5.235 7.175-3.52m-7.205-4.978v8.499V11.4m14.079 2.2h3.31v-3.309h-3.31zm0 5.923h3.31v-3.309h-3.31zm0 5.922h3.31v-3.309h-3.31zm6.077-14.974h10.77M35.26 13.36h8.152m-8.152 2.887h10.77m-10.77 2.889h8.152m-8.152 2.888h10.77m-10.77 2.887h8.152M8.426 41.697a2.166 2.166 0 1 0 4.333 0 2.166 2.166 0 0 0-4.333 0zM17.57 44.2a2.166 2.166 0 1 0 4.333-.001 2.166 2.166 0 0 0-4.332 0zm10.15-8.01a2.166 2.166 0 1 0 4.332 0 2.166 2.166 0 0 0-4.333 0zm9.225 1.638a2.166 2.166 0 1 0 4.332 0 2.166 2.166 0 0 0-4.332 0zM59.506 13.6a2.166 2.166 0 1 0 4.333 0 2.166 2.166 0 0 0-4.333 0zM29.834 52h15.071v-3H29.834zm-17.317-9.385l5.054 1.083m4.016-.677l6.543-5.55m3.881-.857l4.918.948M60.383 15.45L40.584 36.254m17.75-.351a2.166 2.166 0 1 0 4.332 0 2.166 2.166 0 0 0-4.332 0zm-4.603 3.358V42.6h3.339m0-13.357h-3.34v3.34m13.357 0v-3.34h-3.339m0 13.357h3.34v-3.339M48.146 64.14L42.337 52h-9.709l-5.742 12.14"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  mask: "url(#b)",
  d: "M30.056 23.697l.722.586.932-1.255"
}), React.createElement("path", {
  d: "M61.312 18.636v11.973",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.489,2.444,0.489,2.444,0.489,2.444",
  mask: "url(#b)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 75 64",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/internal_data.svg